import moment from 'moment';

export const columns = [
  {
    field: 'id',
    headerName: 'ID',
    type: 'number',
    hide: true,
    hideable: false,
    filterable: false,
    getApplyQuickFilterFn: undefined,
  },
  {
    field: 'cropName',
    headerName: 'Uprawa',
    minWidth: 150,
    flex: 1,
  },
  {
    field: 'group',
    headerName: 'Wskaźnik',
    minWidth: 150,
    flex: 1,
  },
  {
    field: 'range1',
    headerName: 'Przedział 1',
    minWidth: 150,
    flex: 1,
    valueGetter: (params) => {
      return `${params.row.indexList[0]?.minArea} - ${params.row.indexList[0]?.maxArea} ha`;
    },
  },
  {
    field: 'value1',
    headerName: 'Wartość wskaźnika PLN',
    minWidth: 150,
    flex: 1,
    valueGetter: (params) => {
      return `${params.row.indexList[0]?.incomeValue}`;
    },
  },
  {
    field: 'range2',
    headerName: 'Przedział 2',
    minWidth: 150,
    flex: 1,
    valueGetter: (params) => {
      return `${params.row.indexList[1]?.minArea} - ${params.row.indexList[1]?.maxArea} ha`;
    },
  },
  {
    field: 'value2',
    headerName: 'Wartość wskaźnika PLN',
    minWidth: 150,
    flex: 1,
    valueGetter: (params) => {
      return `${params.row.indexList[1]?.incomeValue}`;
    },
  },
  {
    field: 'range3',
    headerName: 'Przedział 3',
    minWidth: 150,
    flex: 1,
    valueGetter: (params) => {
      return `${params.row.indexList[2]?.minArea}${
        params.row.indexList[2]?.maxArea > 100
          ? '+'
          : ' ' + params.row.indexList[2]?.maxArea
      } ha`;
    },
  },
  {
    field: 'value3',
    headerName: 'Wartość wskaźnika PLN',
    minWidth: 150,
    flex: 1,
    valueGetter: (params) => {
      return `${params.row.indexList[2]?.incomeValue}`;
    },
  },
  {
    field: 'expiryDate',
    headerName: 'Data obowiązywania',
    minWidth: 150,
    flex: 1,
    renderCell: (params) => {
      return moment.unix(params.value / 1000).format('DD-MM-YYYY');
    },
  },
];
